export default "__VITE_ASSET__ByBfc7on__"